import { Status } from "~/models";

const resourceStatuses: Status[] = [
    {
        id: "1",
        name: "Not submitted",
    },
    {
        id: "2",
        name: "Submitted",
    },
    {
        id: "3",
        name: "Planned",
    },
];

export default resourceStatuses;
